// Modules
// =============================================================================

import $ from 'zepto';
import App from 'views/app';


// Document Ready
// =============================================================================

$(() => {
  // Create App
  new App();
}).bind(window);


// WEBPACK FOOTER //
// ./src/js/main.js